export const sources = [
    "Design errors and omissions",
    "Scope creep",
    "Unforeseen site conditions",
    "Inadequate project planning",
    "Technology failures",
    "Contractual liabilities",
    "Regulatory non-compliance",
    "Intellectual property issues",
    "Environmental regulations",
    "Budget overruns",
    "Client non-payment",
    "Market fluctuations",
    "Workplace accidents",
    "Labor shortages",
    "Employee turnover",
    "Health and environmental hazards",
    "Cyber attacks",
    "Loss of critical data",
    "Unauthorized access",
    "Project failures",
    "Client disputes",
    "Competitive pressure"
]